<template>
	<div style="height: 100%;">
		<Header></Header>

		<!-- 浮动 -->
		<div class="floating-container">
			
			<a v-for="(item, index) in routers" :href="item.url" @mouseenter="showIndex = index" @mouseleave="showIndex = null">
				<div class="flex-center" :class="index%2==0 ? 'odd-floating' : 'even-floating'">
					<div>
						<p v-if="showIndex == index">{{item.label}}</p>
						<el-image v-else :src="item.icon" style="max-width: 30px;"></el-image>
					</div>
				</div>
			</a>
			
			<!-- <a :href="vrLink" @mouseenter="zhanguanShow = true" @mouseleave="zhanguanShow = false">
				<div class="odd-floating flex-center">
					<div>
						<p v-if="zhanguanShow">数字展馆</p>
						<el-image v-else src="/static/img/icon/zhanguan.png" style="width: 29px;height: 25px;"></el-image>	
					</div>
				</div>
			</a>
			<a href="/dtdl" @mouseenter="dituShow = true" @mouseleave="dituShow = false">
				<div class="even-floating flex-center">
					<div>
						<p v-if="dituShow">地图导览</p>
						<el-image v-else src="/static/img/icon/location.png" style="width: 24px;height: 33px;"></el-image>
					</div>
				</div>
			</a>
			<a href="/rmjz" @mouseenter="rongmeiShow = true" @mouseleave="rongmeiShow = false">
				<div class="odd-floating flex-center">
					<div>
						<p v-if="rongmeiShow">融媒矩阵</p>
						<el-image v-else src="/static/img/icon/wechat.png" style="width: 32px;height: 27px;"></el-image>
					</div>
				</div>
			</a>
			<a href="/booking" @mouseenter="canguanShow = true" @mouseleave="canguanShow = false">
				<div class="even-floating flex-center">
					<div>
						<p v-if="canguanShow">参观预约</p>
						<el-image v-else src="/static/img/icon/clock.png" style="width: 30px;height: 30px;"></el-image>
					</div>
				</div>
			</a>
			<a href="/suggestion" @mouseenter="liuyanShow = true" @mouseleave="liuyanShow = false">
				<div class="odd-floating flex-center">
					<div>
						<p v-if="liuyanShow">留言咨询</p>
						<el-image v-else src="/static/img/icon/kefu.png" style="width: 28px;height: 30px;"></el-image>
					</div>
				</div>
			</a> -->

			<el-backtop target="#app" style="width: 60px;height: 60px;position: static;" >
				<div :key="loadRoute" :class="routers.length%2==0 ? 'odd-floating' : 'even-floating'" class="flex-center" @mouseenter="upShow = true" @mouseleave="upShow = false">
					<div>
						<p v-if="upShow">返回顶部</p>
						<el-image v-else src="/static/img/icon/go_top.png" style="width: 31px;height: 26px;"></el-image>
					</div>
				</div>
			</el-backtop>
		</div>


		<div>
			<div class="info-container flex-center">
				<div class="flex-center" style="margin-top: 50px; margin-bottom: 20px;width: 1200px;">
					<el-row class="news-container">
						<el-row style="margin-top: 20px;height: 30px;" class="text-left">
							<div style="margin-left: 20px;">
								<span class="title" style="">资讯动态</span>
								<span class="title-en">Dynamic information</span>
								<a href="/lastestNews"><span class="more-text">more</span></a>
							</div>
						</el-row>
						<el-row style="height: calc(100% - 50px);margin: 0 20px;">
							<el-col :span="12" class="text-left full-height list news-list">
								<ul>
									<li v-for="(item,index) in newsList" :class="{'first-news-item' : index == 0, 'news-item' : true}">
										<a class="link" style="color: #FFFFFF;" :href="'/detail?id=' + item.id + '&pid=' + item.pid">{{item.title}}</a>
									</li>

								</ul>
							</el-col>
							<el-col :span="12" class="flex-center full-height" style="padding-top: 20px;padding-bottom: 30px;">

								<swiper class="news-banner" :options="swiperOption" ref="newsSwiper">
									<swiper-slide v-for="item in newsBanners" :key="item.id">
										<a :href="'/detail?id=' + item.id + '&pid=' + item.pid" class="full-parent">
											<img :src="item.banner" class="full-parent">
										</a>
									</swiper-slide>
								</swiper>

							</el-col>
						</el-row>

					</el-row>
					<el-row class="notice-container">
						<el-row class="text-left title-bar">
							<div style="margin-left: 20px;">
								<span class="title">通知公告</span>
								<span class="title-en" style="color: #333333">Announcements</span>
								<a href="/notice" target="_blank"><span class="more-text">more</span></a>
							</div>
						</el-row>
						<el-row style="height: calc(100% - 50px);margin: 0 20px;" class="list">
							<ul>
								<li v-for="(item, index) in noticeList" class="text-left">
									<div class="flex-center" style="justify-content: flex-start;">
										<div :class="'list-num-container num-' + (index + 1)"></div>
										<a class="notice-item" :href="'/notice/detail?id=' +item.id">{{item.title}}</a>
									</div>
								</li>
							</ul>
						</el-row>
					</el-row>
				</div>
			</div>

			<el-row type="flex" justify="center">
				<div class="section-container">
					<div v-for="item in columns" class="section full-parent">
						<a :href="getColumnUrl(item)" class="full-parent">
							<el-image :src="item.img" class="full-parent"></el-image>
						</a>
					</div>
				</div>
			</el-row>
			<div class="flex-center" style="margin: 15px 0;">
				<div>
					<div v-for="(list, i) in columnLinks" class="flex section-container" :style="i == 1 ? 'margin-top:10px' : ''">
						<div v-for="(item, index) in list" class="section-horizontal flex-center" :style="index == 0 ? 'margin-right: 10px;' : 'margin-left: 10px;' ">
							<a :href="item.link" class="section-text">
								<img :src="item.img" :alt="item.title" class="full-parent"></img>
							</a>
						</div>
					</div>
				</div>


			</div>
			<!-- 建筑轮播图 -->
			<div id="certify" style="margin-top: 20px;">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<template v-for="(item,index) in buildings">
							<div class="swiper-slide" :key="index">
								<a :href="'/detail/building?id=' + item.id">
									<img :src="item.img" />
									<p class="des-txt">{{item.name}}</p>
								</a>
							</div>
						</template>
					</div>
				</div>
			</div>

			<!-- gif -->
			<div>
				<img src="/static/img/园区动图.gif" style="width: 1200px;margin-top: -40px;margin-bottom: 10px;"/>
			</div>

			<!-- 友情链接 -->
			<div class="links-container">
				<p class="link-container-title">友情链接</p>
				<div class="flex-center">
					<a v-for="item in links" :href="item.link" target="_blank" style="margin-left: 30px;margin-right: 30px;">
						<div>
							<el-image class="link-img" :src="item.img"></el-image>
							<!-- <p class="link-title">{{item.name}}</p> -->
						</div>
					</a>
				</div>
			</div>
		</div>

		<Footer></Footer>
	</div>
</template>
<script>
	import Header from '../../components/Header';
	import Footer from '../../components/Footer';
	import api from '../../http/common'
	import noticeApi from '../../http/notice'
	import newsApi from '../../http/lastest-news'
	import detailApi from '../../http/detail'
	export default {
		name: "Home",
		components: {
			Header,
			Footer
		},
		data() {
			return {
				routers : [],
				newsList: [{
						url: "#111",
						title: "晋冀鲁豫烈士陵园召开2020年度党支部书记述职报告会",
					},
					{
						url: "#222",
						title: "中共晋冀鲁豫烈士陵园委员会所辖党支部  开展主题党"
					},
					{
						url: "#333",
						title: "晋冀鲁豫烈士陵园举办《辉煌70年英雄精神永放光芒》"
					},
					{
						url: "#333",
						title: "晋冀鲁豫烈士陵园举办《辉煌70年英雄精神永放光芒》"
					},
					{
						url: "#333",
						title: "晋冀鲁豫烈士陵园举办《辉煌70年英雄精神永放光芒》"
					}
				],
				noticeList: [],
				columns: [],
				links: [],
				buildings: [],
				columnLinks: [],
				swiperOption: {
					observer: true,
					observeParents: true,
					loop: false,
					autoplay: 1000,
					slidesPerview: 'auto',
					loopAdditionalSlides: 2,
					autoplayDisableOnInteraction: false,
				},
				newsBanners: [],
				showIndex : null,
				zhanguanShow : false,
				dituShow : false,
				rongmeiShow : false,
				canguanShow : false,
				liuyanShow : false,
				upShow : false,
				loadRoute : 0,
				vrLink : "https://c011zri5q.720think.com/t/c011zri5q?def_sid=1078891&ath=201.28127950160996&atv=-0.9669219136809172"
			}
		},
		created() {
			this.getHoverRouters();
			this.getAllColumns()
			this.getNotice()
			this.getNews()
			this.getLinks()
			this.getBuildings()
			this.getAllColumnLinks()
		},
		methods: {
			getHoverRouters(){
				api.getHoverRouters().then(res => {
					this.routers = res;
					this.loadRoute = 1;
				})
			},
			getAllColumns() {
				const _this = this;
				api.getAllColumns().then(res => {
					_this.columns = res;
				})
			},
			getNotice() {
				var page = {
					size: 6,
					page: 0,
					sort: "publish_time,desc"
				}
				const _this = this;
				noticeApi.getData(page).then(res => {
					_this.noticeList = res.content;
				});
			},
			getNews() {
				var page = {
					size: 5,
					page: 0,
					sort: "publish_time,desc"
				}
				const _this = this;
				newsApi.getData(page).then(res => {
					_this.newsList = res.content;
					var banners = new Array();
					res.content.forEach(i => {
						if (i.banner != null && i.banner != '') {
							banners.push(i)
						}
					})
					_this.newsBanners = banners;
				});
			},
			getColumnUrl(data) {
				if (data.type == 3) {
					//外链
					return data.url;
				}
				return "/col/detail?id=" + data.id;
			},
			getLinks() {
				const _this = this;
				api.getLinks().then(res => {
					_this.links = res.content;
				})
			},
			getBuildings() {
				const _this = this;

				var page = {
					size: 3,
					page: 0,
					sort: "id,desc"
				}
				detailApi.getBuildings(page).then(res => {
					_this.buildings = res.content;
				})
			},
			getAllColumnLinks() {
				const _this = this;
				api.getColumnLinks().then(res => {
					var outter = new Array()
					for (var i = 0; i < res.length; i += 2) {
						outter.push(res.slice(i, i + 2))
					}
					_this.columnLinks = outter
				})
			}

		},
		mounted() {
			setTimeout(() => {
				let certifySwiper = new Swiper('#certify .swiper-container', {
					observer: true,
					observeParents: true,
					watchSlidesProgress: true,
					slidesPerView: 'auto',
					centeredSlides: true,
					loop: true,
					loopedSlides: 5,
					autoplay: 3000,
					onProgress: function(swiper, progress) {
						for (let i = 0; i < swiper.slides.length; i++) {
							let slide = swiper.slides.eq(i);
							let slideProgress = swiper.slides[i].progress;
							let modify = 1;
							if (Math.abs(slideProgress) > 1) {
								modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
							}
							let translate = slideProgress * modify * 260 + 'px';
							let scale = 1 - Math.abs(slideProgress) / 5;
							let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
							slide.transform('translateX(' + translate + ') scale(' + scale + ')');
							slide.css('zIndex', zIndex);
							slide.css('opacity', 1);
							if (Math.abs(slideProgress) > 3) {
								slide.css('opacity', 0);
							}
						}
					},
					onSetTransition: function(swiper, transition) {
						for (let i = 0; i < swiper.slides.length; i++) {
							let slide = swiper.slides.eq(i)
							slide.transition(transition);
						}
					},
				});

			}, 1000);
		},
		computed: {
			newsSwiper() {
				return this.$refs.newsSwiper.swiper
			}
		}
	}
</script>
<style scoped>
	#certify {
		position: relative;
		width: 1200px;
		margin: 0 auto
	}

	#certify .swiper-container {
		padding-bottom: 60px;
	}

	#certify .swiper-slide {
		/* width: 889px; */
		height: 374px;
		width: 520px;
	  /* height: 408px; */
		background: #fff;
		box-shadow: 0 8px 30px #ddd;
	}

	#certify .swiper-slide img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.news-banner {
		width: 370px;
		height: 230px;
	}

	.des-txt {
		position: absolute;
		bottom: 0;
		padding: 10px 0;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.4);
		width: 100%;
	}

	.main-container {}

	.floating-container {
		position: fixed;
		bottom: 10%;
		right: 20px;
		z-index: 9999;
	}

	.info-container {
		width: 100%;
		background-color: #FFFFFF;
		height: 435px;
	}

	.news-container {
		width: 982px;
		height: 385px;
		background: #980F25;
	}

	.notice-container {
		margin-left: 20px;
		width: 502px;
		height: 385px;
		background: #FFFFFF;
		box-shadow: 0px 7px 21px 6px rgba(140, 11, 31, 0.04);
	}

	.notice-container * {
		color: #333333 !important;
	}

	.news-container li {
		color: #FFFFFF;
	}

	.notice-container li {
		list-style: none;
		margin-top: 20px;
	}

	.title {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}

	.title-en {
		height: 12px;
		font-size: 16px;
		font-family: Arial;
		font-weight: 400;
		color: #FFFFFF;
		opacity: 0.1;
		text-transform: uppercase;
	}

	.more-text {
		float: right;
		font-size: 12px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		text-transform: uppercase;
		margin-right: 20px;
	}

	.link {
		color: #FFFFFF;
	}

	.link::visit {
		color: #FFFFFF;
	}

	.first-news-item {
		list-style-image: url("/static/img/icon/point_white_fill.png") !important;
	}

	.news-item {
		list-style-image: url("/static/img/icon/point_red_fill.png");
		margin-top: 25px;
		list-style-position: inside;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		line-height: 16px;
	}

	.notice-item {
		width: 320px;
		line-height: 16px;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.news-list {
		padding-left: 8px;
		padding-right: 30px;
	}

	.list {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.title-bar {
		margin-top: 20px;
		height: 30px;
	}

	.list-num-container {
		height: 31px;
		width: 50px;
		background-repeat: no-repeat;
		display: inline-block;
		margin-right: 5px;
		background-size: contain;
	}

	.num-1 {
		background-image: url("/static/img/icon/01.png");
	}

	.num-2 {
		background-image: url("/static/img/icon/02.png");
	}

	.num-3 {
		background-image: url("/static/img/icon/03.png");
	}

	.num-4 {
		background-image: url("/static/img/icon/04.png");
	}

	.num-5 {
		background-image: url("/static/img/icon/05.png");
	}

	.num-6 {
		background-image: url("/static/img/icon/06.png");
	}

	.section-container {
		width: 1200px;
	}

	.section {
		background: #F0F0F0;
		margin-top: 15px;
		height: 174px;
	}

	.section-horizontal {
		width: 50%;
		height: 263px;
		background: rgba(247, 237, 89, 0.2);
	}

	.section-text {
		color: #FFC24C;
		height: 100%;
		width: 100%;
		font-size: 36px;
		font-family: PingFang SC, Microsoft YaHei;
		font-weight: 500;
		color: #FFC24C;
		/* opacity: 0.5; */
		text-align: center;
		line-height: 179px;
	}

	.odd-floating {
		width: 60px;
		height: 60px;
		background: #980F25;
	}
	.odd-floating p{
		color: #FFFFFF;
		font-size: 20px;
		width: 40px;
	}

	.even-floating {
		width: 60px;
		height: 60px;
		background: #FFFFFF;
	}
	
	.even-floating p{
		color: #000000;
		font-size: 20px;
		width: 40px;
	}

	.mask {
		display: flex;
		align-items: center;
		position: absolute;
		left: 0px;
		bottom: 0px;
		background: rgba(0, 0, 0, 0.6);
		width: 300px;
		height: 54px;
		z-Index: 998;
		justify-content: space-between;
	}

	.link-container-title {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin-bottom: 30px;
	}

	.links-container {
		margin-bottom: 60px;
	}

	.link-img {
		height: 69px;
		width: auto;
		max-width: 200px;
	}

	.link-title {}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue